<template>
    <div class="home_container">
        <el-container>
            <el-aside width="200px">
                <div class="logo">
                    <a href="javascript:;">
                        <img src="../image/home_logo.png" alt=""/>
                    </a>
                </div>
                <el-row>
                    <el-col>
                        <el-menu
                            :default-active="$route.name"
                            class="el-menu-vertical-demo"
                            background-color="#333951"
                            text-color="#fff"
                            active-text-color="#fff"
                            unique-opened
                            router
                            mode="vertical"
                        >
                            <el-submenu
                                v-for="(item, index) in menuList"
                                :key="index"
                                :index="index.toString()"
                            >
                                <template slot="title">
                                    <i class="el-icon-menu"></i>
                                    <!-- <i :class="'el-icon-' + item.icon"></i> -->
                                    <span>{{ item.meta.title }}</span>
                                </template>
                                <el-menu-item-group>
                                    <el-menu-item
                                        @click="addTab(children)"
                                        v-for="(children, i) in item.children"
                                        :key="i"
                                        :index="children.path"
                                    >
                                        <div
                                            class="messageHint"
                                            v-if="children.path == 'communication' && messsage > 0"
                                        >
                                            {{ messsage > 99 ? "99+" : messsage }}
                                        </div>
                                        {{ children.meta.title }}
                                    </el-menu-item>
                                </el-menu-item-group>
                            </el-submenu>
                        </el-menu>
                    </el-col>
                </el-row>
                <!-- <el-scrollbar class="page-component__scroll"
                  >>

                </el-scrollbar> -->
            </el-aside>
            <el-container>
                <el-header height="80px">
                    <!-- 面包屑导航 -->
                    <div class="header_left">
                        <div class="folded">
                            <i class="el-icon-s-fold"></i>
                        </div>
                        <el-breadcrumb separator="">
                            <el-breadcrumb-item :to="{ path: 'home' }"
                            >首页
                            </el-breadcrumb-item
                            >
                            <el-breadcrumb-item v-if="current">{{
                                    $route.meta.superior
                                }}
                            </el-breadcrumb-item>
                            <el-breadcrumb-item :to="current.path" v-if="current">{{
                                    $route.meta.title
                                }}
                            </el-breadcrumb-item>
                        </el-breadcrumb>
                    </div>
                    <div class="header_right">
                        <div class="user_message">
                            <i class="el-input__icon iconfont iconxiaoxi"></i>
                        </div>
                        <div class="interval"></div>
                        <div class="user_info">
                            <div class="user_img">
                                <img src="../image/userimg.png" alt=""/>
                            </div>

                            <div class="user_name">
                                <el-dropdown trigger="click" @command="commandList">
                  <span class="el-dropdown-link">
                    {{
                          userName
                      }}<i class="el-icon-arrow-down el-icon--right"></i>
                  </span>
                                    <el-dropdown-menu slot="dropdown">
<!--                                        <el-dropdown-item command="1">重新授权</el-dropdown-item>-->
<!--                                        <el-dropdown-item command="0">解除授权</el-dropdown-item>-->
                                        <el-dropdown-item command="2">修改密码</el-dropdown-item>
                                        <el-dropdown-item command="3">退出登录</el-dropdown-item>
                                    </el-dropdown-menu>
                                </el-dropdown>
                            </div>
                        </div>
                    </div>
                </el-header>
                <!-- Tab导航切换 -->
                <div class="Tab">
                    <el-tag
                        :key="tag.path"
                        v-for="(tag, index) in tags"
                        :closable="tag.path !== 'home'"
                        :disable-transitions="false"
                        @close="deleteClose(tag, index)"
                        @click="changeMenu(tag)"
                        :effect="$route.name == tag.path ? 'dark' : 'plain'"
                    >
                        {{ tag.meta.title }}
                    </el-tag>
                </div>
                <el-main>
                    <router-view></router-view>
                </el-main>
            </el-container>
        </el-container>
        <!-- 修改密码弹窗 -->
        <el-dialog
            title="修改密码"
            :visible.sync="dialogVisible"
            width="480px"
            :before-close="changeHandleClose"
        >
            <el-form
                :model="ruleForm"
                status-icon
                :rules="rules"
                ref="ruleForm"
                label-width="0"
                class="demo-ruleForm"
            >
                <el-form-item prop="oldPassword">
                    <el-input
                        type="password"
                        v-model="ruleForm.oldPassword"
                        show-password
                        placeholder="请输入原始密码（必填）"
                    ></el-input>
                </el-form-item>
                <el-form-item prop="newPassword">
                    <el-input
                        type="password"
                        show-password
                        v-model="ruleForm.newPassword"
                        placeholder="请输入新密码（必填）"
                    >
                    </el-input>
                </el-form-item>
                <el-form-item prop="Password">
                    <el-input
                        type="password"
                        show-password
                        v-model="ruleForm.Password"
                        placeholder="再次输入新始密码（必填）"
                    ></el-input>
                </el-form-item>
            </el-form>
            <span slot="footer" class="dialog-footer">
        <el-button @click="cancel('ruleForm')" class="cancel">取 消</el-button>
        <el-button
            type="primary"
            @click="goChangeBtn('ruleForm')"
            class="add_new_btn"
        >确 定</el-button
        >
      </span>
        </el-dialog>
        <order-msg-detail :message="messageData" :msgDialogVisible="msgDialogVisible"
                          @close="closeMsgDialog"></order-msg-detail>
    </div>
</template>

<script>
import {
    InfoAjax,
    RoutersAjax,
    updatePwd,
    countNumPC,
    refresh,
    authorize,
    elRefreshToken,
    sentGzdMsg, addChannelConnection
} from "../api/index";
import {mapState, mapMutations,mapActions} from "vuex";
import orderMsgDetail from "@/components/order-msg-detail/OrderMsgDetail";
import mqtt from "mqtt";
import { MQTT_MQTTIP, MQTT_USERNAME, MQTT_PASSWORD } from "@/utils/MQtt";
export default {
    components: {
        orderMsgDetail
    },
    data() {
        //表单验证
        var validatorPassword = (rule, value, callback) => {
            console.log(value);
            if (value === "") {
                callback(new Error("密码不能为空"));
            } else if (!/^[a-zA-Z0-9]{3,20}$/.test(value)) {
                callback(new Error("密码格式错误,必须且只含有数字和字母，3-20位!"));
            } else {
                callback();
            }
        };

        // 再次输入新密码
        var validatorCheckPass = (rule, value, callback) => {
            console.log(value);
            if (value === "") {
                callback(new Error("请再次输入密码"));
            } else if (value !== this.ruleForm.newPassword) {
                callback(new Error("两次输入密码不一致!"));
            } else {
                callback();
            }
        };
        return {
            mqttClient:null,//mqtt客户端
            mqttOption:{
                connectTimeout: 40000, //在收到 CONNACK 之前等待的时间
                clientId: '',
                username: MQTT_USERNAME,
                password: MQTT_PASSWORD,
                clean: true, //设置为 false 以在离线时接收 QoS 1 和 2 消息
                reconnectPeriod: "1000", //重连时间
                keepalive: 60
            },
            mtopics: "topic/+",
            mtopic: "",
            reconnectNum:0,//socket重连次数
            reconnectMsgNum:0,
            ruleForm: {
                oldPassword: "",
                newPassword: "",
                Password: ""
            },
            socket: null,
            msgSocket:null,
            notifyList: [],//消息通知
            messageData: null,
            msgDialogVisible: false,
            dialogVisible: false,
            menuList: {},
            infoList: {},
            userName: "",
            phonenumber: "",
            rules: {
                oldPassword: [
                    {
                        required: true,
                        message: "原密码不能为空",
                        trigger: "blur"
                    }
                ],
                newPassword: [
                    {
                        required: true,
                        validator: validatorPassword,
                        trigger: "blur"
                    }
                ],
                Password: [
                    {
                        required: true,
                        validator: validatorCheckPass,
                        trigger: "blur"
                    }
                ]
            },
            refreshMtTokenTask:null
        };
    },
    mounted() {

    },
    created() {
        this.getInfoAjax();
        this.getRoutersAjax();
        this.countNumPCGet();
        window.viewMsg = this.viewMsg;
        window.closeMsg = this.closeMsg;
        window.toMessageDetail=this.toMessageDetail

        // this.initMqtt();
        console.log('created')
        if(this.refreshMtTokenTask){
            clearInterval(this.refreshMtTokenTask);
            this.refreshMtTokenTask = null;
        }
        //4分钟刷新
        this.refreshMtTokenTask = setInterval(()=>{
            this.refreshMtToken();
        },1000*60*5)
        // this.openMessage();
    },
    beforeDestroy() {
        if(this.refreshMtTokenTask){
            clearInterval(this.refreshMtTokenTask);
            this.refreshMtTokenTask = null;
            console.log('清除刷新token任务');
        }
       /* this.reconnectNum = 4;
        this.socket.close();*/
        this.reconnectMsgNum = 4;
        this.msgSocket.close(1000,'no');
       /* this.mqttClient.end(true, null, () => {
            this.mqttClient = null;
            console.log('退出关闭mqtt')
        });*/

    },
    computed: {
        //获取vuex的标签集合数据
        ...mapState({
            tags: state => state.tab.tabsList,
            current: state => state.tab.currentMenu,
            messsage: state => state.message.message
        })
    },
    methods: {
        ...mapActions(['setMsgContent']),
        async countNumPCGet() {
            const {data: res} = await countNumPC();
            this.$store.commit("getMessage", res.data);
        },
        // 用户个人信息
        async getInfoAjax() {
            const {data: res} = await InfoAjax();
            if (res.code !== 200)
                return this.$message({
                    message: res.msg,
                    type: "error"
                });
            this.infoList = res;
            this.userName = res.user.userName;
            this.phonenumber = res.user.phonenumber;
            sessionStorage.setItem("userName", this.userName);
            sessionStorage.setItem("Phone", this.phonenumber);
            sessionStorage.setItem("permission", JSON.stringify(res.permissions));
            sessionStorage.setItem("userId", res.user.userId);
            this.$store.commit("setUserInfo", res.user);
            // this.initSocket();
            this.initMsgSocket();
            this.refreshMtToken();
        },
        // 用户权限信息
        async getRoutersAjax() {
            const {data: res} = await RoutersAjax();
            if (res.code !== 200)
                return this.$message({
                    message: res.msg,
                    type: "error"
                });
            this.menuList = res.data;
            console.log(res.data, "路由")
        },
        // handleOpen(key, keyPath) {
        //   console.log(key, keyPath);
        // },
        // handleClose(key, keyPath) {
        //   console.log(key, keyPath);
        // },
        addTab(item) {
            //调用vuex的selectMenu方法存储数据
            console.log(item)
            this.$store.commit("selectMenu", item);
        },
        ...mapMutations({
            close: "closeTab"
        }),
        //关闭标签
        deleteClose(tag, index) {
            console.log(tag);
            let length = this.tags.length - 1;
            //vuex调方法的另一种写法
            this.close(tag);
            // 如果关闭的标签不是当前路由的话，就不跳转
            if (tag.home !== this.$route.home) {
                return;
            }
            // 关闭的标签是最右边的话，往左边跳转一个
            if (index === length) {
                this.$router.push({name: this.tags[index - 1].path});
            } else {
                // 否则往右边跳转
                this.$router.push({name: this.tags[index].path});
            }
        },
        //选择标签跳转路由
        changeMenu(item) {
            console.log(item)
            this.$router.push({name: item.path});
            this.$store.commit("selectMenu", item);
        },
        commandList(command) {
            if (command == 3) this.logOut();

            if (command == 2) this.changePwsBtn();
            if (command == 1) this.resetToken();
            if (command == 0) this.delRefreshToken();
        },
        delRefreshToken() {
            elRefreshToken().then(res => {
                if (res.data && res.data.code == 200) {
                    this.$message.success(res.data.msg)
                } else {
                    this.$message.error(res.data.msg)
                }
                localStorage.removeItem('isAuthMt')
                this.getInfoAjax();
            })
        },
        resetToken() {
            authorize({
                uri: 'https://test.youjiaminsu.cn/dist/auth'
            }).then(result => {
                console.log(result, '获取美团授权地址')
                window.location = result.data.data;
            })
            /*refresh().then(res=>{
                if(res.data&&res.data.code==200){
                    this.$message.success('刷新成功',res.data)
                    for(let key in res.data.data){
                        localStorage.setItem(key,res.data.data[key]);
                    }
                    this.$store.commit("setMtToken",res.data.data.accessToken)
                }else {
                    this.$message.error(res.data.msg)
                }
            })*/
        },
        changeHandleClose(done) {
            this.$confirm("确认关闭？")
                .then(_ => {
                    done();
                })
                .catch(_ => {
                });
        },
        // 取消按钮
        cancel(formName) {
            this.$refs[formName].resetFields();
            this.dialogVisible = false;
        },
        // 修改密码弹窗
        changePwsBtn() {
            this.dialogVisible = true;
        },
        goChangeBtn(formName) {
            this.$refs[formName].validate(async valid => {
                if (valid) {
                    const {data: res} = await updatePwd(this.ruleForm);
                    if (res.code !== 200) {
                        return this.$message({
                            message: res.msg,
                            type: "error"
                        });
                    }
                    this.ruleForm = {
                        oldPassword: "",
                        newPassword: "",
                        Password: ""
                    };
                    this.dialogVisible = false;
                    return this.$message({
                        message: res.msg,
                        type: "success"
                    });
                } else {
                    return false;
                }
            });
        },
        //退出登录
        logOut() {
            this.$confirm("确定退出登录？")
                .then(_ => {
                    this.$router.push("/");
                    sessionStorage.clear();
                    this.$store.state.user = "";
                    if (this.socket) {
                        this.socket.close()
                    }
                    this.notifyList.forEach(item=>{
                        item.notify?.close();
                    })
                    this.notifyList=[];
                    this.$store.commit("remove", [
                        {
                            path: "home",
                            name: "home",
                            meta: {
                                title: "首页"
                            },
                            icon: "home"
                        }
                    ]);
                    return;
                })
                .catch(_ => {
                });
        },
        getDataSources(dataSources) {
            let enumStatus = {
                '1': '微信小程序',
                '2': '悠家',
                '3': '美团',
                '4': '途家',
                '5': '小猪',
                '6': '爱彼迎'
            }
            return enumStatus[dataSources];
        },
        //订单状态变更通知弹窗
        openOrderMessage(data) {
            //判断是否为订单消息不是则直接return

            let sources = this.getDataSources(data.orders.dataSources);
            let tit = ``;
            if (data.orders.type <= 3) {
                tit = `来自${sources}的新订单`
            } else {
                tit = `订单状态发生变化!`
            }
            let str = `来自于${sources}的订单:${data.orders.id}状态发生了变化`;
            let msgId = Math.random().toString(36).slice(3, 10);
            let msgTemplate =
                `<div class="msgTemplate">
                            <div style="width: 74%">
                                <div class="message_tit">
                                    <i class="el-icon-warning" style="font-size:18px;padding-right: 5px"></i>
                                    <span  style="font-size:18px;font-weight: 800;height: 100%;">${tit}</span>
                                </div>
                                <div class="message_detail">
                                    <span>${str}</span>
                                </div>
                            </div>
                            <div class="right_but">
                                <div onclick="viewMsg('` + msgId + `')">查看</div>
                                <div onclick="closeMsg('` + msgId + `')">关闭</div>
                                <div onclick="closeMsg('all')">关闭全部</div>
                            </div>
                </div>`
            let notify = this.$notify({
                title: '',
                dangerouslyUseHTMLString: true,
                showClose: false,
                customClass: 'order_msg',
                duration: 0,
                offset: 90,
                message: msgTemplate
            });
            this.notifyList.push({
                msgId: msgId,
                notify: notify,
                data: data
            })
        },
        viewMsg(msgId) {
            console.log(msgId)
            let notify = this.notifyList.find(item => item.msgId == msgId);
            console.log(notify);
            this.messageData = notify?.data;

            notify?.notify?.close();
            let index = this.getMsgIndex(this.notifyList,msgId,'msgId');
            console.log("index",index)
            if(index==-1) {
                this.toMessageDetail(msgId);
                return;
            }
            this.msgDialogVisible = true;
            this.notifyList.splice(index, 1);
            console.log(this.notifyList);
        },
        toMessageDetail(msgId){
            this.closeMsg(msgId)
           this.$router.push({name:'communication'})
        },
        getMsgIndex(list,msgId,prop){
            let index=-1;
            try {
                list.forEach((item,ind)=>{
                    if(item[prop] === msgId){
                        index = ind
                        throw new Error('')
                    }
                })
            }catch (e){

            }
            return index;
        },
        closeMsg(msgId) {
            if(msgId == 'all'){
                this.notifyList.forEach(item=>{
                    item?.notify?.close();
                })
                return;
            }
            console.log(msgId, this.notifyList);
            let notify = this.notifyList.find(item => item.msgId == msgId);
            console.log(notify);
            notify?.notify?.close();
            let index = this.getMsgIndex(this.notifyList,msgId,'msgId');
            console.log("index",index)
            this.notifyList.splice(index, 1);
            console.log(this.notifyList);
        },
        closeMsgDialog() {
            this.msgDialogVisible = false;
        },
        //消息通知
        openMessage(data) {


            let tit =  `来自${data}的消息`;


            let msgId = Math.random().toString(36).slice(3, 10);
            let msgTemplate =
                `<div class="msgTemplate">
                            <div style="width: 74%">
                                <div class="message_tit">
                                    <i class="el-icon-warning" style="font-size:18px;padding-right: 5px"></i>
                                    <span  style="font-size:18px;font-weight: 800;height: 100%;">新消息通知</span>
                                </div>
                                <div class="message_detail">
                                    <span>${data }</span>
                                </div>
                            </div>
                            <div class="right_but">
                                <div onclick="toMessageDetail('` + msgId + `')">查看</div>
                                <div onclick="closeMsg('` + msgId + `')">关闭</div>
                                 <div onclick="closeMsg('all')">关闭全部</div>
                            </div>
                </div>`
            let notify = this.$notify({
                title: '',
                dangerouslyUseHTMLString: true,
                showClose: false,
                customClass: 'order_msg',
                offset: 90,
                duration: 0,
                message:msgTemplate

            });
            this.notifyList.push({
                msgId: msgId,
                notify: notify,
                data: data
            })
        },
        isJSON(str) {
            if (typeof str == 'string') {
                try {
                    var obj=JSON.parse(str);
                    if(typeof obj == 'object' && obj ){
                        return true;
                    }else{
                        return false;
                    }

                } catch(e) {
                    console.log('error：'+str+'!!!'+e);
                    return false;
                }
            }
            console.log('It is not a string!')
        },
        initSocket() {
            let userId = sessionStorage.getItem('userId')
            this.socket = new WebSocket(this.socketUrl+'/'+userId);
            this.socket.onmessage = (msg) => {
                console.log("接收订单消息:", msg)
                try {
                    // 转换成功则为订单消息
                    if(this.isJSON(msg.data)){
                        let msgObj=JSON.parse(msg.data);
                        let msgKeys = Object.keys(msgObj.order);
                        let obj={}
                        if(msgObj.dataSources){
                            msgKeys.forEach(item=>{
                                obj=Object.assign(obj,msgObj[item])
                            })
                            this.openOrderMessage(obj);
                        }
                    }

                }catch (e) {

                }




            }
            this.socket.onopen = () => {
                console.log("socket连接成功");
                this.reconnectNum=0;
                this.sendMsg('socket连接成功')
            };
            this.socket.onerror = (e) => {
                console.log("socket连接失败:",e);
            };
            this.socket.onclose = this.closeSocket;
        },
        sendMsg(msg) {
            this.socket.send(msg);
        },
        closeSocket(e) {
            console.log("socket已断开",e);
            if(this.reconnectNum<=3){
                console.log("重连socket...");
                this.initSocket();
                this.reconnectNum++;
                console.log(this.reconnectNum)
                return;
            }


        },
        closeMsgSocket(e,msg){
            console.log("消息socket已断开",e,msg);
            if(this.reconnectMsgNum<=3){
                console.log("重连socket...");
                this.initMsgSocket();
                this.reconnectMsgNum++;
                console.log(this.reconnectNum)
                return;
            }
        },
        // 初始化消息
        initMsgSocket(){
            let userId = sessionStorage.getItem('userId')
            this.msgSocket = new WebSocket(`${this.socketMsgUrl}/${userId}`);
            this.msgSocket.onmessage = (msg) => {
                if( msg.toString()!='收到'){
                    try {
                        // 转换失败则为普通消息
                        if(!this.isJSON(msg.data)){
                            this.setMsgContent( msg.data.toString())
                            this.openMessage( msg.data.toString())

                        }else{
                            console.log('订单')
                            // 转换成功则为订单
                            try {
                                let msgObj=JSON.parse(msg.data);


                                this.openOrderMessage(msgObj);
                            }catch (e){
                                console.log('错误',e)
                            }

                        }
                    }catch (e){
                        this.setMsgContent( msg.data.toString())
                        this.openMessage( msg.data.toString())
                    }

                }


            }
            this.msgSocket.onopen = () => {
                this.reconnectMsgNum=0;
                console.log("消息连接成功");

            };
            this.msgSocket.onerror = (e) => {
                console.log("消息连接失败:",e);
            };
            this.msgSocket.onclose = this.closeMsgSocket;
        },
        //初始化mqtt链接
        initMqtt(){
            function S4() {
                return (((1 + Math.random()) * 0x10000) | 0).toString(32).substring(1);
            }
            let MathRandom =
                S4() + S4() + "-" + S4() + "-" + S4() + "-" + S4() + "-" + S4() + S4() + S4();
            let MqttUserId = "clientid-" + MathRandom;
            this.mqttOption.clientId= MqttUserId;
            this.mqttClient =  mqtt.connect(MQTT_MQTTIP, this.mqttOption);
            this.listenMqtt();
        },
        listenMqtt(){
            // 连接mqtt
            this.mqttClient.on("connect", e => {
                console.log("全局连接成功");
                this.mqttClient.subscribe(this.mtopics, err => {
                    if (!err) {
                        console.log("全局订阅成功:" + this.mtopics);
                    }
                });
            });
            // 接收推送消息
            this.mqttClient.on("message", (mtopics, message) => {
                // let timeStatus = null;
                // let that = this;
                // if (timeStatus != null) {
                //   clearTimeout(timeoutflag);
                // }
                // var timeoutflag = setTimeout(function() {
                //   timeStatus++;
                //   console.log("接收推送信息：", message.toString(), "主题", topic, 222); //````````````
                //   that.msg = message.toString();
                //   that.countNumPCGet();
                //   that.getChatLogListPCAjax();
                // }, 500);

                console.log("全局接收推送信息：",'主题：'+mtopics, message.toString()); //````````````

                try {
                    let type = JSON.parse(message.toString())?.type;
                    //9999为管理端小程序，不进行提醒
                    if(type!='9999'&& mtopics!='topic/MTSendMsg'){
                        this.openMessage( message.toString())
                    }
                }catch (e) {
                    this.openMessage( message.toString())
                }



                // sentGzdMsg({content:message.toString(),topic:mtopics})
            });
            // 断开发起重连
            this.mqttClient.on("reconnect", error => {
                console.log("正在重连...", error);
            });
            // 链接异常处理
            this.mqttClient.on("error", error => {
                console.log("连接失败...", error);
            });
        },
        //刷新美团token

        refreshMtToken(){
            let config = {
                refreshToken:'',
                scope:'',
                openId:''
            }
            let userInfo = JSON.parse(sessionStorage.getItem('userInfo'))
            let mtConfig = localStorage.getItem('mtConfig-'+userInfo.userId);
            if(mtConfig){
                config = {...JSON.parse(mtConfig)}
            }else {
                const {refreshToken,mtScope,mtopenId} = userInfo;
                config = {
                    refreshToken,
                    scope:mtScope,
                    openId:mtopenId
                }
            }
            if (config.refreshToken) {
                this.$store.commit('setMTConfig', config)
                refresh({
                    refreshToken: config.refreshToken,
                    scope:config.scope,
                    openId:config.openId
                }).then(res => {
                    if (res.data && res.data.code == 200) {
                        console.log('刷新美团token成功', res.data)
                        for (let key in res.data.data) {
                            localStorage.setItem(key, res.data.data[key]);
                        }
                        this.$store.commit("setMtToken", res.data.data.accessToken)
                        addChannelConnection({
                            username: res.data.data.nickname,
                            mtToken: res.data.data.accessToken,
                            openId: res.data.data.openId,
                            mtRefreshToken:userInfo.refreshToken,
                            scope:userInfo.mtScope,
                        })
                    } else {
                        // this.$message.error(res.data.msg)
                    }
                })
            }
        }
    }
};
</script>

<style lang="less" scoped>
.home_container {
    height: 100%;
}

/deep/ .el-menu-item-group__title {
    padding: 0;
}

.el-header {
    background-color: #fff;
    color: #333;
    text-align: center;
    line-height: 80px;
}

.el-menu-item {
    background-color: rgba(0, 0, 0, 0.1);
}

.messageHint {
    font-size: 12px;
    padding: 0 6px;
    height: 16px;
    border-radius: 8px;
    background-color: red;
    line-height: 16px;
    color: #fff;
    text-indent: 1px;
    position: absolute;
    right: 0px;
    top: 0px;
}

.el-menu-item.is-active {
    background-color: #f6b439 !important;
}

// .element::-webkit-scrollbar {
//   width: 0 !important;
// }
::-webkit-scrollbar {
    /*隐藏滚轮*/
    display: none;
}

.el-aside {
    background-color: #333951;
    color: #333;

    .el-icon-location {
        margin-right: 18px;
    }

    .page-component__scroll {
        height: 100%;
    }

    .el-row {
        margin-top: 80px;
    }
}

.el-menu {
    border-right: none;
}

.el-main:has(.listingLinking){
    background-color: #f7f8fa;
}
.el-main {
    // box-shadow: 0px 4px 16px rgba(0, 0, 0, 0.05);
    // overflow-y: hidden;
    background-color: #fff;
    color: #333;
    padding: 24px;
}

.el-container {
    height: 100%;
}

body > .el-container {
    margin-bottom: 40px;
}

.el-container:nth-child(5) .el-aside,
.el-container:nth-child(6) .el-aside {
    line-height: 260px;
}

.el-container:nth-child(7) .el-aside {
    line-height: 320px;
}

.logo {
    z-index: 333;
    position: fixed;
    top: 0px;
    left: 0px;
    background: #333951;
    width: 200px;
    height: 80px;

    a {
        display: inline-block;
        width: 100%;
        height: 100%;

        img {
            position: absolute;
            top: 0;
            left: 40px;
        }
    }
}

.header_left {
    position: relative;
    float: left;
    height: 80px;
    width: 400px;

    .folded {
        position: absolute;
        top: 7px;
        left: 24px;

        .el-icon-s-fold {
            font-size: 36px;
        }
    }

    .el-breadcrumb {
        position: absolute;
        top: 28px;
        left: 84px;
    }
}

.header_right {
    float: right;
    height: 80px;

    .user_message {
        float: left;
        line-height: 90px;

        .iconxiaoxi:before {
            font-weight: bold;
            font-size: 30px;
        }
    }

    .user_info {
        cursor: pointer;
        float: left;

        .user_img {
            overflow: hidden;
            float: left;
            width: 40px;
            height: 40px;
            border-radius: 50%;
            // background-color: #f6b439;
            margin: 20px 10px 20px 40px;
            line-height: 40px;
        }

        .user_name {
            float: right;
        }
    }

    img {
        width: 40px;
        height: 40px;
    }

    .interval {
        float: left;
        margin: 27px 0 26px 38px;
        border-left: 2px solid #333;
        width: 2px;
        height: 27px;
    }
}

/deep/ .el-menu-item {
    // margin-left: 22px;
    background-color: #212844 !important;
    text-indent: 20px;
}

.Tab {
    width: 100%;
    height: 50px;
    border-top: 1px solid #e1e1e1;
    border-bottom: 1px solid #e1e1e1;
    box-shadow: 0px 4px 16px rgba(0, 0, 0, 0.05);
    line-height: 45px;
    padding-left: 10px;

    .el-tag {
        margin-right: 15px;
        cursor: pointer;
    }

    .el-tag--dark {
        background-color: #f6b439;
        border-color: #f6b439;
        color: #fff;
    }
}

/deep/ .el-breadcrumb__inner {
    font-size: 18px;
}

.add_new_btn {
    width: 72px;
    height: 36px;
    line-height: 2px;
    margin-left: 24px;
    background-color: #f6b439;
    border: 1px solid #f6b439;
}

.cancel {
    width: 72px;
    height: 36px;
    line-height: 2px;

    background: #f2f2f2;
    border: 1px solid #e1e1e1;
}

/deep/ .el-dialog {
    border-radius: 10px;
    // padding: 0 60px;
}

// /deep/.el-dialog__header {
//   padding: 0;
//   padding-top: 40px;
//   font-weight: bold;
//   font-size: 20px;
//   text-align: center;
// }
// /deep/.el-dialog__body {
//   padding: 0;
//   padding-top: 45px;
// }
// /deep/.el-dialog__footer {
//   padding: 25px 0 40px;
// }
</style>
